import Chart from 'chart.js/auto';

window.addEventListener("DOMContentLoaded", () => {

	const ctx = document.getElementById('dispositionPieChart');
	if (ctx) {

		const chartData = document.querySelector('[data-acp-data]');
		const acpData = JSON.parse(chartData.getAttribute('data-acp-data').replace(/'/g, '"'));

		const labels = acpData.map(item => item.label);
		const data = acpData.map(item => item.value);
		const bgcolors = ['#325f61', '#287056', '#9bc46b', '#74b470', '#8b90bc', '#603ea5', '#6b44ab'];
	

		const dispositionChart = new Chart(ctx, {
			type: 'pie',
			data: {
				labels: labels,
				datasets: [{
					data: data,
					backgroundColor: bgcolors,
					borderWidth: 0
				}]
			},
			options: {
				responsive: true,
				plugins: {
					legend: {
						display: false
					}
				}
			}
		});

		// Dynamic legend as before
		const legendContainer = document.getElementById('chartLegend');
		const legendLabels = dispositionChart.data.labels;
		const colors = dispositionChart.data.datasets[0].backgroundColor;
		let legendHtml = '<ul>';
		legendLabels.forEach((label, i) => {
			legendHtml += `<li><span style="background-color:${colors[i % colors.length]}"></span>${label}</li>`;
		});
		legendHtml += '</ul>';
		legendContainer.innerHTML = legendHtml;
	}
});